import React, {Component} from 'react';
import {connect, dispatch} from 'react-redux';
import {bindActionCreators} from 'redux';
import Typekit from 'react-typekit';

import {fetchCategoryPosts, ROUTER} from '../actions/index';

import Header from '../components/header';
import MapKioskStatic from '../components/map-kiosk-static';
import Footer from '../components/footer';
import NavBar from './parts/NavBar';


class MapperCB extends Component {
    constructor(props){
	    super(props);

	    this.state = {
		    posts: [
				{ id: 1, title: "Rudolph Arthur ", lat: "39.745500", lng: "-75.882200", description: "<p>Over Big Elk Creek north of Lewisville - 1.5 west of jct PA 472 on PA 841, then left on SR 3005 and turn left 0.4 mile on Rudolph Camp Road</p>", image: "01_rudolph.jpg" },
				{ id: 2, title: "Glen Hope", lat: "39.727000", lng: "-75.907500", description: "<p>Over Little Elk Creek southeast of Hickory Hill 1.6 miles on Providence Road. Just north of the MD state line.</p>", image: "02_glen-hope.jpg" },
				{ id: 3, title: "Linton Stevens ", lat: "39.756300", lng: "-75.912300", description: "<p>Over Little Elk Creek northeast of Hickory Hill (less than a mile) on Elk/New London TR 344</p>", image: "03_linton-stevens.jpg" },
				{ id: 4, title: "Speakman #1 ", lat: "39.929300", lng: "-75.822500", description: "<p>North of intersection with Rt 841 (Doe Run) about 1 mill on Rt 82. Then go east on SR 3047 (Covered Bridge Rd.)</p>", image: "04_speakman-1.jpg" },
				{ id: 5, title: "Speakman # 2 ", lat: "39.912200", lng: "-75.798000", description: "<p>(Private property)</p>", image: "05_speakman-2.jpg" },
				{ id: 6, title: "Hayes Clark", lat: "39.912300", lng: "-75.798000", description: "<p>PA82 southeast 1.2 miles from jct with PA841 in Doe Run, north on Mc Corkles Rock Rd. through the gate 0.3 miles to the bridge (Private property)</p>", image: "06_hayes-clark.jpg" },
				{ id: 7, title: "Gibson ", lat: "39.976200", lng: "-75.683000", description: "<p>South of Downington (US 30) by 2.5 miles 0n US 322, then just left on Harmony Hill Road</p>", image: "07_gibson.jpg" },
				{ id: 8, title: "Larkin", lat: "40.082463", lng: "-75.685584", description: "<p>Grpahite Mine Rd. Chester Springs, PA</p>", image: "08_larkin.jpg" },
				{ id: 9, title: "Sheeder Hall", lat: "40.147800", lng: "-75.620300", description: "<p>South east of Buckton on Sheeder Road</p>", image: "09_sheeder-hall.jpg" },
				{ id: 10, title: "Kennedy", lat: "40.140300", lng: "-75.576300", description: "<p>West Seven Sars Rd</p>", image: "10_kennedy.jpg" },
				{ id: 11, title: "Rapp Dam", lat: "40.138200", lng: "-75.552800", description: "<p>West of Phoenixville on East Pikeland Road (TR447 ).</p>", image: "11_rapps-dam.jpg" },
				{ id: 12, title: "Bartram", lat: "39.989800", lng: "-75.437000", description: "<p>West of Newton Square about 1.5 miles off Goshen Road</p>", image: "12_bartrams.jpg" },
				{ id: 13, title: "Mercer", lat: "39.931500", lng: "-75.981700", description: "<p>South East of Christiana off Noble Road</p>", image: "13_mercer.jpg" },
				{ id: 14, title: "Pine Grove", lat: "39.793500", lng: "-76.044300", description: "<p>South east of Kirkwood off PA 472 on Ashville / Forge Rd</p>", image: "14_pine-grove.jpg" },
				{ id: 15, title: "Knox", lat: "40.087229", lng: "-75.456276", description: "<p>Valley Forge Park, Yellow Springs road.</p>", image: "15_knox.jpg" },
				{ id: 16, title: "Chester County Visitors Bureau", lat: "39.868648", lng: "-75.6725627", description: "<p></p>", image: "VisitorsBuilding.jpg", icon: "cvb-marker.png" }
		    ],
	    }
    }
    
    componentWillMount() {
    
    }

    componentWillReceiveProps(nextProps) {
    	    
    }

    componentDidUpdate() {
        document.title = `${RT_API.siteName} - ${RT_API.siteDescription}`;
    }

    render() {
        console.log("mapperf2f state posts is:");
        console.log( this.state.posts );
        return (
            <section className="kiosk-wrapper">
                <Typekit kitId="eab1tpm" />
                <MapKioskStatic markers={this.state.posts} path="covered-bridges"  title="Covered Bridges"/>
            </section>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({fetchCategoryPosts, dispatch}), dispatch)
}

export default connect(null, mapDispatchToProps)(MapperCB)


// WEBPACK FOOTER //
// ./src/containers/mapper-covered-bridges.js